<template>
	<div
		id="vehicleForm"
		class="z-maximumPlusUltraMinusOne fixed inset-0 h-full w-full overflow-hidden bg-gray-600 bg-opacity-30 transition-all duration-500"
		:class="{
			'overflow-y-hidden bg-opacity-0': !dialogs.vehicleOpen,
			'pointer-events-none': !dialogs.vehicleOpen,
		}"
		@click="dialogs.vehicleOpen = false"
		@open="openForm"
	>
		<div
			class="max-w-8xl z-1 absolute bottom-0 right-0 top-0 h-full max-h-screen w-full overflow-x-hidden overflow-y-scroll overscroll-none transition-all duration-500"
			:class="{ 'translate-x-full': !dialogs.vehicleOpen }"
			@click.stop=""
		>
			<VehicleForm />
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { watch, onMounted, getCurrentInstance } from 'vue'
	import VehicleForm from '../VehicleForm/VehicleForm.vue'
	import { Steps, useFormStore } from '../../stores/form'
	import { useDialogStore } from '../../stores/dialog'
	import * as Sentry from '@sentry/vue'
	import { useConfigStore } from '../../stores/config'

	const form = useFormStore()
	const dialogs = useDialogStore()
	const { config } = useConfigStore()

	onMounted(() => {
		if (window.location.href.includes('formOpen=true')) {
			dialogs.vehicleOpen = true
		}

		document.addEventListener('click', event => {
			const target = event.target as HTMLElement

			if (target?.closest('[data-driveo-form-open]')) {
				if (import.meta.env.PROD) {
					// Sentry initialization
					if (!Sentry.getCurrentScope()?.getClient()) {
						Sentry.init({
							app: getCurrentInstance()?.appContext.app,
							dsn: 'https://a2cb8e1911b5457a8a5d243713b15396@o4504063612289024.ingest.sentry.io/4504063621988353',
							environment: import.meta.env.VITE_APP_SENTRY_ENV,
							maxBreadcrumbs: 10,
							tracesSampleRate: 0.1,

							replaysSessionSampleRate: 0.01,
							replaysOnErrorSampleRate: 0.1,

							beforeSend(event) {
								if (config?.origin) {
									event.fingerprint = event.fingerprint?.length
										? [...event.fingerprint, config.origin]
										: [config.origin]
								}
								return event
							},

							integrations: [Sentry.replayIntegration({ maskAllText: false })],
						})
					}
				}
				openForm()
			}
		})
	})

	watch(
		() => dialogs.vehicleOpen,
		curr => {
			if (curr) {
				document.documentElement.style.overflow = 'hidden'
				document.body.classList.add('Driveo-form-open')
			} else {
				if (form.currentStep.terminate) {
					form.setStep(Steps.AboutYourRide)
				}
				document.documentElement.style.overflow = 'unset'
				document.body.classList.remove('Driveo-form-open')
			}
		},
	)

	const openForm = () => {
		dialogs.vehicleOpen = true
	}
</script>
